import { useEffect, useState, useMemo } from "react";
import { axiosRequest } from "../helpers/axios";
import { ApiCoursesResponse, FilterData, Section } from "../interfaces/course";
import { AxiosResponse } from "axios";
import { getFilterPrefix, processData, transformedArrayForFilters } from "../helpers/acceleratorFilters";
import { netflixFilterChosen, netflixFilterCleared } from "../components/mixPanelEvents/mixPanelEvents";


export const orderByDocument = [
    "Chipping & Bunkers: 3 and 4 Game",
    "Chipping & Bunkers: 4 Clubs Game - Bunker",
    "Putting: 6 Foot PGA Tour Wheel Drill",
    "Putting: Total Feet Of Putts Drill",
    "Putting: 42 Foot PGA Tour 2-Putt Drill",
    "Mental Game: Mental Score",
    "Wedge Game: 50-100 Yard Proximity Drill",
    "Wedge Game: Cone Games",
    "Driving: Fairway Finder Drill",
    "Ball Striking: Iron Adversity Training Drill",
    // NEW >
    "Ball Striking: Ace In The Hole Drill",
    "Ball Striking: PGA Tour Proximity Drill From 150-175 Yards",
    "Chipping & Bunkers: 10 Ball 30",
    "Wedge Game: Games of 3",
    "Ball Striking: Shot Shaping Game",
    "Chipping & Bunkers: 20-Yard Backyard Shot Drill",
    "Putting: 21 Game",
    "Chipping & Bunkers: 10 Ball Make Game",
    "Chipping & Bunkers: Leap Frog Game",
    "Chipping & Bunkers: Bunker Elimination Game",
    "Chipping & Bunkers: Bunker Darts Game",
    "Chipping & Bunkers: 23 Bunker Game",
    "Chipping & Bunkers: 4 Ball Game",
    "Chipping & Bunkers: Wedge Hole Out Drill",
    "Chipping & Bunkers: 5 in 9 Adversity Drill",
    "Chipping & Bunkers: 10 Commitments Bunker Drill",
]

declare global {
    interface Window {
        popularCoursesPriority: any;
        netflixCourseButtonsSplit:any;
    }
 }

export const useAccelerators = (): [FilterData[], boolean, Section[], (filterType: string, isChecked: boolean) => void, (filterType: string, category: string, isChecked: boolean) => void, Record<string, string[]>, () => void, (filterType: string, category: string) => void, Section, Section, (filterType: string, category: string) => void] => {
    const [filterData, setFilterData] = useState<FilterData[]>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [courses, setCourses] = useState<Section[]>([]);
    const [popularCourses, setPopularCourses] = useState<Section | null>();
    const [recomendedCourses, setRecomendedCourses] = useState<Section | null>();
    const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);

    const initialFilters: Record<string, string[]> = {};
    const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => {
        filterData.forEach(filter => {
            initialFilters[filter.filterType] = [];
        });
        return initialFilters;
    });

    useEffect(() => {
        const getAllFetchedData = async () => {
            await axiosRequest("GET", '/wp-json/pg/v2/sc/netflix').then((response: AxiosResponse<ApiCoursesResponse>) => {
                const { data } = response.data;

                setLoaded(true);
                if(window.popularCoursesPriority){
                    [data.sections[0], data.sections[1]] = [data.sections[1], data.sections[0]];
                }

                const popularSection = { 
                    ...data.sections[1],
                    things: [...data.sections[1].things].sort((a, b) => {
                      const indexA = orderByDocument.indexOf(a.name);
                      const indexB = orderByDocument.indexOf(b.name);
                  
                      const finalIndexA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
                      const finalIndexB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
                  
                      return finalIndexA - finalIndexB;
                    })
                  };

                data.sections[1] = popularSection;
                setCourses(data.sections);
                setPopularCourses(popularSection);
                setRecomendedCourses(data.sections[2]);
            }).catch(error => console.error(`Error: ${error}`)).finally(() => setLoaded(true));
        };
        getAllFetchedData();
    }, []);

    const filteredCourses = useMemo(() => {
        let filtered = [...courses];
        Object.keys(selectedFilters).forEach(filterType => {
            selectedFilters[filterType].forEach((filter) => {
                filtered = filtered.map(section => ({
                    ...section,
                    things: section.things.filter(thing => thing.filters.includes(getFilterPrefix(filterType) + `${filter}`))
                }));
            });
        });
        return filtered;
    }, [courses, selectedFilters]);

    const memoizedFilterData = useMemo(() => {
        const { acceleratorType, drillType } = processData(filteredCourses);

        return [
            { filterType: "Accelerator", data: transformedArrayForFilters(acceleratorType) },
            { filterType: "Drill", data: transformedArrayForFilters(drillType) },
        ];
    }, [filteredCourses]);

    useEffect(() => {
        setFilterData(memoizedFilterData);
    }, [memoizedFilterData]);

    const handleResetFilter = () => {
        netflixFilterCleared(selectedFilters);
        setSelectedFilters(initialFilters);
        
    };

    const handleFilterTypeCheckboxChange = (filterType: string, isChecked: boolean, isMobile?: boolean) => {
        if (isMobile) {
            setSelectedFilters(prev => {
                const updatedFilters = { ...prev };
                updatedFilters[filterType] = [];
                return updatedFilters;
            });
        }
        setSelectedFilters(prev => {
            const updatedFilters = { ...prev };
            if (isChecked) {
                updatedFilters[filterType] = [];
            }
            return updatedFilters;
        });
       
    };

    const handleFilterCheckboxChange = (filterType: string, category: string, isChecked: boolean) => {
        if (isCheckboxDisabled) return;

        setIsCheckboxDisabled(true);
        setSelectedFilters(prev => {
            const updatedFilters = { ...prev };
            if (isChecked) {
                if (updatedFilters[filterType]) {
                    updatedFilters[filterType].push(category);
                } else {
                    updatedFilters[filterType] = [category];
                }
                netflixFilterChosen(filterType,category,updatedFilters);
            } else {
                updatedFilters[filterType] = updatedFilters[filterType].filter(c => c !== category);
                netflixFilterCleared(updatedFilters,category,filterType)
            }
            
            console.log("updated filters are >> ",category);
            return updatedFilters;
        });

        setTimeout(() => {
            setIsCheckboxDisabled(false);
        }, 200);
    };

    const handleFilterCheckboxChangeOnMobile = (filterType: string, category: string) => {
        setSelectedFilters(prev => {
            const updatedFilters = { ...prev };
            if (!updatedFilters[filterType]) {
                updatedFilters[filterType] = [];
            }

            const currentIndex = updatedFilters[filterType].indexOf(category);
            if (currentIndex === -1) {
                updatedFilters[filterType].push(category);
                netflixFilterChosen(filterType,category,updatedFilters);
            } else {
                updatedFilters[filterType].splice(currentIndex, 1);
                netflixFilterCleared(updatedFilters,category,filterType)
            }
            return updatedFilters;
        });
    };

    const handleMobileFilterChange = (filterType: string, category: string) => {
        setSelectedFilters(prev => {
            const updatedFilters = { ...prev };

            if (updatedFilters[filterType]) {
                if (updatedFilters[filterType].includes(category)) {
                    updatedFilters[filterType] = updatedFilters[filterType].filter(c => c !== category);
                } else {
                    updatedFilters[filterType].push(category);
                }
            } else {
                updatedFilters[filterType] = [category];
            }
            return updatedFilters;
        });
        
    };

    return [filterData, loaded, filteredCourses, handleFilterTypeCheckboxChange, handleFilterCheckboxChange, selectedFilters, handleResetFilter, handleMobileFilterChange, popularCourses!, recomendedCourses!, handleFilterCheckboxChangeOnMobile];
};
